import * as Yup from "yup";
import { TFunction } from "i18next";

export const menuItemValidationSchema = (t: TFunction) =>
    Yup.object().shape({
        name: Yup.string().trim().required(t("validation.required")),
        types: Yup.array().min(1, t("validation.required")),
        categories: Yup.array().min(1, t("validation.required")),
        portions: Yup.array()
            .of(
                Yup.object().shape({
                    name: Yup.string().required(t("validation.required")),

                    volume: Yup.number()
                        .required(t("validation.required"))
                        .test(
                            "volume-range",
                            t("The value must be between 1.0 and 10000.0"),
                            (value) => value === undefined || (value >= 1 && value <= 10000)
                        ),

                    price: Yup.number().required(t("validation.required")).min(0.01, t("Minimum value is 0.01")),
                })
            )
            .min(1, t("validation.required"))
            .test("unique-portion-names", t("A portion with this name already exists"), function (portions) {
                if (!portions) return true;

                const names = portions.map((portion) => (portion?.name ?? "").trim().toLowerCase());

                const indicesByName = new Map<string, number[]>();

                names.forEach((name, index) => {
                    if (!name) return;
                    const list = indicesByName.get(name) ?? [];
                    list.push(index);
                    indicesByName.set(name, list);
                });

                const errorIndexes: number[] = [];
                indicesByName.forEach((indexes) => {
                    if (indexes.length > 1) {
                        errorIndexes.push(...indexes.slice(1));
                    }
                });

                if (errorIndexes.length === 0) {
                    return true;
                }

                const errors = errorIndexes.map((idx) =>
                    this.createError({
                        path: `portions[${idx}].name`,
                        message: t("A portion with this name already exists"),
                    })
                );

                return new Yup.ValidationError(errors);
            }),
        unit: Yup.number().required(t("validation.required")),
    });
